import styled from "styled-components";

export const Container = styled.div`
	@media (max-width: 560px) {
		width: 100%;
		overflow: auto;
	}
`;

export const AreaStatus = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const TextCenter = styled.div`
	text-align: center;
`;

export const ColumnClaim = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
`;
